<template>
	<div>
		<router-view />
	</div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useStore } from 'vuex'
import cookie from "cookie.js";

const store = useStore()
onMounted(() => {
	store.dispatch('getWebsitConfig')
})

if (!store.state.login.userInfo.id && cookie.get('accessToken')) {
    store.dispatch('getUserInfo')
}
</script>

<style lang="scss" scoped>

</style>
